import SAflag from '../assets/images/saudi-arabia.png';
import globalFlag from '../assets/images/global.png';
import { RegionTypes } from '../constants/regionType';

export const Regions = [
	{ name: 'Global', code: RegionTypes.Global, icon: globalFlag },
	{ name: 'Saudi Arabia', code: RegionTypes.SaudiArabia, icon: SAflag },
];
